var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.73 16.5H8.73V12H7.73V16.5ZM15.27 16.5H16.27V7H15.27V16.5ZM11.5 16.5H12.5V14H11.5V16.5ZM11.5 12H12.5V10H11.5V12ZM5.616 20C5.15533 20 4.771 19.846 4.463 19.538C4.155 19.23 4.00067 18.8453 4 18.384V5.616C4 5.15533 4.15433 4.771 4.463 4.463C4.77167 4.155 5.156 4.00067 5.616 4H18.385C18.845 4 19.2293 4.15433 19.538 4.463C19.8467 4.77167 20.0007 5.156 20 5.616V18.385C20 18.845 19.846 19.2293 19.538 19.538C19.23 19.8467 18.8453 20.0007 18.384 20H5.616ZM5.616 19H18.385C18.5383 19 18.6793 18.936 18.808 18.808C18.9367 18.68 19.0007 18.5387 19 18.384V5.616C19 5.462 18.936 5.32067 18.808 5.192C18.68 5.06333 18.5387 4.99933 18.384 5H5.616C5.462 5 5.32067 5.064 5.192 5.192C5.06333 5.32 4.99933 5.46133 5 5.616V18.385C5 18.5383 5.064 18.6793 5.192 18.808C5.32 18.9367 5.461 19.0007 5.615 19",
    fill: "#1F2124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.4dc1e863a265afd9734f9d70f073846d.svg";
export { ForwardRef as ReactComponent };